import base from '@/api/base.api';
import axios from 'axios';
const namespace = 'group-file-document';

export default {
    getGroupForShareholders: (params) => {
        return axios.post(`${base.baseUrl}/${namespace}/onboarding-shareholder`, params)
    },
    checkFileDocsByGroupUser: (params) => {
        return axios.post(`${base.baseUrl}/${namespace}/check-fileDocs-by-group-user`, params)
    },
}
